import React from 'react';
import moment from "moment";
import neoLogo from "../../../../assets/images/Neo_Logo_A.svg";

/**
 * PrintableEventReport
 * Componente oculto na tela que renderiza o relatório de avaliações
 * no formato de lista de competição, otimizado para impressão A4.
 * 
 * Segue o mesmo padrão do PrintableReceipt (class component + inline styles).
 */
class PrintableEventReport extends React.Component {
    render() {
        const { evaluations, event, tenantName, tenantLogo } = this.props;

        if (!evaluations || evaluations.length === 0) return null;

        const isTechnical = event?.type === 'technical';

        const dateStart = event?.startDate
            ? moment(event.startDate).format("DD/MM/YYYY")
            : "--";
        const dateEnd = event?.endDate
            ? moment(event.endDate).format("DD/MM/YYYY")
            : "--";

        const approvedCount = evaluations.filter(
            ev => ev.status === "PASSED" || ev.xpPassAwarded
        ).length;

        return (
            <div style={{ padding: "30px 40px", fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif", color: "#333", backgroundColor: "#fff" }}>

                {/* ═══ CABEÇALHO ═══ */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #eee", paddingBottom: "20px", marginBottom: "24px" }}>
                    {/* ESQUERDA: Logo */}
                    <div style={{ flex: "0 0 auto", minWidth: "120px" }}>
                        {tenantLogo && (
                            <img src={tenantLogo} alt="Logo" style={{ maxHeight: "70px", maxWidth: "160px", objectFit: "contain" }} />
                        )}
                    </div>

                    {/* DIREITA: Nome + Dados do Evento */}
                    <div style={{ textAlign: "right", flex: "1 1 auto", paddingLeft: "15px" }}>
                        <h2 style={{ margin: "0 0 6px 0", fontSize: "14px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                            {tenantName || "Empresa"}
                        </h2>
                        <h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "700", color: "#111" }}>
                            {event?.name || "Resultados Oficiais"}
                        </h3>

                        <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}>
                            <strong>Período:</strong> {dateStart} a {dateEnd}
                        </p>
                    </div>
                </div>

                {/* ═══ TABELA DE RESULTADOS ═══ */}
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "24px", fontSize: "13px" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#212529", color: "#fff", textAlign: "left" }}>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "5%", textAlign: "center" }}>#</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "30%" }}>Atleta / Aluno</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "18%" }}>Professor</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "14%" }}>Nível</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", textAlign: "center", width: "10%" }}>Aprov.</th>
                            {isTechnical && (
                                <th style={{ padding: "10px 12px", fontWeight: "600", textAlign: "center", width: "10%" }}>Fund.</th>
                            )}
                            <th style={{ padding: "10px 12px", fontWeight: "600", textAlign: "center", width: "7%" }}>Status</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "14%" }}>Avaliador</th>
                        </tr>
                    </thead>
                    <tbody>
                        {evaluations.map((ev, index) => {
                            const passed = ev.status === "PASSED" || ev.xpPassAwarded;

                            let fundamentalText = "N/A";
                            const objectivesList = ev.objectives || [];
                            const topicsList = objectivesList.flatMap(obj => obj.topics || []);
                            const fundamentals = topicsList.filter(c => c.isFundamental);
                            if (fundamentals.length > 0) {
                                fundamentalText = fundamentals.every(c => c.achieved) ? "Sim" : "Não";
                            }

                            return (
                                <tr
                                    key={ev.id || index}
                                    style={{
                                        borderBottom: "1px solid #dee2e6",
                                        backgroundColor: index % 2 === 0 ? "#fff" : "#f8f9fa"
                                    }}
                                >
                                    <td style={{ padding: "9px 12px", textAlign: "center", fontWeight: "600", color: "#888" }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ padding: "9px 12px", fontWeight: "600", color: "#111", textTransform: "uppercase", fontSize: "12px" }}>
                                        {ev.memberName || ev.memberName || "Desconhecido"}
                                    </td>
                                    <td style={{ padding: "9px 12px", color: "#555", textTransform: "uppercase", fontSize: "11px" }}>
                                        {ev.teacherName || ev.employeeName || "-"}
                                    </td>
                                    <td style={{ padding: "9px 12px", color: "#555", fontSize: "12px" }}>
                                        {ev.activityName || ev.levelName || "-"}
                                    </td>
                                    <td style={{ padding: "9px 12px", textAlign: "center", fontWeight: "700", color: "#333" }}>
                                        {ev.progressPercent != null ? `${ev.progressPercent}%` : "-"}
                                    </td>
                                    {isTechnical && (
                                        <td style={{ padding: "9px 12px", textAlign: "center", color: fundamentalText === "Sim" ? "#2ecc71" : fundamentalText === "Não" ? "#e74c3c" : "#888", fontWeight: "600", fontSize: "12px" }}>
                                            {fundamentalText}
                                        </td>
                                    )}
                                    <td style={{ padding: "9px 12px", textAlign: "center", fontWeight: "700", fontSize: "13px", color: passed ? "#2ecc71" : "#999" }}>
                                        {passed ? "AP" : "-"}
                                    </td>
                                    <td style={{ padding: "9px 12px", color: "#777", textTransform: "uppercase", fontSize: "11px" }}>
                                        {ev.employeeName || ev.updatedBy?.name || "Sistema"}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                {/* ═══ RESUMO ═══ */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "40px", marginBottom: "40px" }}>
                    {/* Estatísticas */}
                    <div style={{ flex: 1 }}>
                        <div style={{ backgroundColor: "#f8f9fa", padding: "16px 20px", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px", fontSize: "14px" }}>
                                <span style={{ color: "#666" }}>Total de Avaliações:</span>
                                <span style={{ fontWeight: "600", color: "#333" }}>{evaluations.length}</span>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px", fontSize: "14px" }}>
                                <span style={{ color: "#666" }}>Aprovados:</span>
                                <span style={{ fontWeight: "600", color: "#2ecc71" }}>{approvedCount}</span>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }}>
                                <span style={{ color: "#666" }}>Não Aprovados:</span>
                                <span style={{ fontWeight: "600", color: "#e74c3c" }}>{evaluations.length - approvedCount}</span>
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #ddd", fontSize: "15px", fontWeight: "700" }}>
                                <span style={{ color: "#111" }}>Taxa de Aprovação:</span>
                                <span style={{ color: "#333" }}>
                                    {evaluations.length > 0
                                        ? `${Math.round((approvedCount / evaluations.length) * 100)}%`
                                        : "0%"}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Espaço para Assinatura do Organizador */}
                    <div style={{ width: "280px", paddingTop: "60px", textAlign: "center" }}>
                        <div style={{ borderTop: "1px solid #333", paddingTop: "8px" }}>
                            <p style={{ margin: 0, fontSize: "12px", color: "#555", fontWeight: "600" }}>Responsável / Organizador</p>
                        </div>
                    </div>
                </div>

                {/* ═══ RODAPÉ ═══ */}
                <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "2px solid #eee" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                        <div style={{ textAlign: "right" }}>
                            <p style={{ margin: "0 0 5px 0", fontSize: "11px", fontStyle: "italic", color: "#999" }}>
                                Gerado em {moment().format("DD/MM/YYYY [às] HH:mm")}.
                            </p>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginTop: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "700", color: "#aaa", letterSpacing: "1px" }}>POWERED BY</span>
                                <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) opacity(0.6)" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrintableEventReport;
